<template>
	<div style="width: 100%;" id="box">
		<!-- <el-row :gutter="10">
			<el-col :xs="8" :sm="6" :md="4" :lg="3" :xl="1">12</el-col>
			<el-col :xs="4" :sm="6" :md="8" :lg="9" :xl="11">34</el-col>
			<el-col :xs="4" :sm="6" :md="8" :lg="9" :xl="11">45</el-col>
			<el-col :xs="8" :sm="6" :md="4" :lg="3" :xl="1">56</el-col>
			</el-row> -->
		<div class="my-account">
			<h2>{{$t('labseth.myaccount')}}</h2>
		</div>
		<el-dialog :title="$t('labseth.addaccount')" :visible.sync="addminerdialog"
			:width="addpaymentaccountDialogWidth" :close-on-click-modal="false" :modal="false" :destroy-on-close="true"
			center>
			<el-form ref="mineraccount" :model="mineraccount" label-width="80px">

				<el-form-item :label="$t('labseth.accountName')">
					<el-input v-model="mineraccount.minerName">
						<template slot="prepend">ar_</template>
					</el-input>
				</el-form-item>
				<el-form-item :label="$t('labseth.remark')">
					<el-input v-model="mineraccount.remark"></el-input>
				</el-form-item>
			</el-form>

			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="openGoogleOPT('subaddMinerAccount')" icon="el-icon-check">
					{{$t('labseth.confirm')}}
				</el-button>
				<el-button type="danger" @click="addminerdialog=false" icon="el-icon-close">{{$t('labseth.cancel')}}
				</el-button>
			</span>
		</el-dialog>

		<el-dialog title="公告" :visible.sync="shownotice" width="30%" center :modal="false">
			<span>
				通知：<br>&nbsp;&nbsp;Alipay通道维护，暂无法进行使用，恢复时间另行通知，请各位用户选择其它提款方式。给您带来的不便，我们深表歉意！<br>&nbsp;&nbsp;Star Map
				Team<br>&nbsp;&nbsp;2022/01/24<br><br>&nbsp;&nbsp;尊敬的各位用户，我们已经将 ETH 辅助工具上传至GitHub: <a
					href='https://github.com/C3Pool/ST-CryptoServer'
					target='_blank'>https://github.com/C3Pool/ST-CryptoServer</a><br>&nbsp;&nbsp;有需要的用户可自行下载搭建。<br>&nbsp;&nbsp;现有的辅助工具将于2022年01月15日停止服务。<br>&nbsp;&nbsp;请各位用户尽快更换！<br>&nbsp;&nbsp;Star
				Map Team<br>&nbsp;&nbsp;2022/01/13
			</span>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="shownotice = false">我知道了</el-button>
			</span>
		</el-dialog>

		<el-dialog :title="$t('labseth.changeaccount')" :visible.sync="echangeMiner"
			:width="addpaymentaccountDialogWidth" :close-on-click-modal="false" :modal="false" :destroy-on-close="true"
			center>

			<el-table :data="minerList" border style="width: 100%">
				<el-table-column prop="id" :label="$t('labseth.accountid')" fit>
				</el-table-column>
				<el-table-column prop="miner_name" :label="$t('labseth.accountName2')" fit>
				</el-table-column>
				<el-table-column prop="remark" :label="$t('labseth.remark')">
				</el-table-column>
				<el-table-column :label="$t('labseth.option')">
					<template slot-scope="scope">
						<el-button size="mini" type="success" @click="chooseminer(scope.row)">{{$t('labseth.select')}}
						</el-button>
						<!-- <el-button
						  size="mini"
												type="danger"
						  @click="deleteMineraccount(scope.row)">删除</el-button> -->
					</template>
				</el-table-column>
			</el-table>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="addMinerAccount" icon="el-icon-plus">{{$t('labseth.addaccount')}}
				</el-button>
			</span>
		</el-dialog>
		<div class="content ">
			<!-- 头部 -->
			<el-row :gutter="20">
				<el-col class="header-col content-header-l" style="background-color:#343434;" :xs="24" :sm="24" :md="8"
					:lg="8" :xl="8">
					<div style="width: 100%;">
						<img src="../../../img/etc.png" height="70" style="float: left;margin-top: 25px" />
						<div class="content-header-l-l">

							<label>{{minerData.miner_name}} &nbsp;</label><img src="../../../img/exchange.png"
								width="20" height="20" @click="exchangeMiner" style="margin-top: 5px;"><br />
							<span>{{minerData.remark}}</span>
						</div>

						<!-- <div class="content-header-l-r">
							
							<span>{{$t('labseth.sfsyobserver')}}</span><br />
							
							<el-tooltip class="item " effect="dark" :content="$t('labseth.observertip')"
								placement="top">
								<el-switch v-model="isobserver" @change="openorcloseobserver()" :active-value="true"
									:inactive-value="false" inactive-color="#ff0000" active-color="#4de700">
								</el-switch>
							</el-tooltip>
							<el-link v-if="isobserver===true" type="danger" class="copyButton"
								style="cursor:pointer;font-size: 1.125rem;" :data-clipboard-text="observerurl"
								@click="copykey"><span style="color: #ffaa00;">
									{{$t('labseth.copyobserver')}}
								</span></el-link>
							<el-link v-if="isobserver===true" type="danger" :href="observerurl" target="_blank"><span
									style="color: #ffaa00;">
									{{$t('labseth.openobserver')}}
								</span></el-link>

						</div> -->

					</div>
				</el-col>



				<el-col class="header-col content-header-middle " :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
					<div class="content-header-r-main  ">

						<!-- 	<div id="" style="height: 100%; width: 80%; margin: auto; padding-top: 15px;  text-align: center;background-color: red;">
				
				<el-divider style="height: 70%"  direction="vertical"></el-divider>
				
				
			</div> -->

						<el-row :gutter="10">
							<el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" class="earnings">

								<div style="">
									<center>
										<span style="">
											{{$t('labseth.lastdayearn')}}

											<el-tooltip class="item" effect="dark"
												:content="$t('labseth.lastdayearndisc')" placement="top">
												<i class="el-icon-question"></i>
											</el-tooltip>


										</span><br>
										<label>{{formatEthBalance(lastdayEarning)}}ETC</label>
									</center>
								</div>


							</el-col>
							<el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" class="earnings">

								<div style="">
									<center>
										<span>
											{{$t('labseth.todayearn')}}
											<el-tooltip class="item" effect="dark"
												:content="$t('labseth.todayearndisc')" placement="top">
												<i class="el-icon-question"></i>
											</el-tooltip>
										</span><br>
										<label>{{formatEthBalance(todayearn)}}ETC</label>
									</center>
								</div>

							</el-col>
						</el-row>
					</div>
				</el-col>

				<el-col class="header-col content-header-r" :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
					<div class="content-header-r-main">

						<center>
							<div style="width: 80%">
								<span style="font-size: 18px;">
									{{$t('labseth.tobesubbalance')}}

								</span><br>

							</div>
							<!-- <label>{{formatEthBalance(minerData.eth_balance)}}ETH</label><el-badge type="warning" class="mark" value="昨日收益" /><br /> -->
							<label>{{formatEthBalance(minerData.etc_balance)}}ETC</label><br />
							<span>≈ {{fix2(formatEthBalance(minerData.etc_balance)*ethPrice.etc2usdt)}}
								USDT</span><br />
							<span>≈ {{(formatEthBalance(minerData.etc_balance*ethPrice.etc2eth))}} ETH</span><br />

							<!-- 	<el-button type="warning"  style="margin-top: -10px;" size="mini" @click="activeName_1='third'" round>
								{{$t('labseth.nowsubbalance')}}
							</el-button> -->
						</center>

					</div>
				</el-col>
			</el-row>
			<!-- 提醒公告 -->
			<br /><br />


			<div class="content-main">


				<el-row :gutter="20">
					<el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
						<div class="grid-content">
							<el-card class="box-card hash-card" style="padding-bottom: 10px;">
								<div slot="header" class="clearfix">
									<span style="font-size: 18px;">{{$t('labseth.hashrate')}}</span>
									<!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
								</div>

								<ul style="margin-top: 10px;">
									<li class="card-li">
										<center>
											{{$t('anonminer.realhahs')}}
											<!-- <el-popover placement="top-start" width="200" trigger="hover"
												:content="$t('anonminer.realhahs_desc')">
												<i class="el-icon-warning-outline" style="color: #476EF6;"
													slot="reference"></i>
											</el-popover> -->
										</center>
									</li>
									<li class="card-li">
										<!-- <center>
											RAW
											<el-popover placement="top-start" width="200" trigger="hover" content="当前算法总算力">
												<i class="el-icon-warning-outline" style="color: #476EF6;" slot="reference"></i>
												
											</el-popover>
										</center> -->
										<center>
											{{$t('anonminer.avghash4')}}
											<el-popover placement="top-start" width="200" trigger="hover"
												:content="$t('anonminer.avghash4_desc')">
												<i class="el-icon-warning-outline" style="color: #476EF6;"
													slot="reference"></i>
												<!-- <el-button slot="reference" size="mini" icon="el-icon-search" circle></el-button> -->
											</el-popover>
										</center>
									</li>
								</ul>


								<ul>
									<li class="card-li">
										<center>
											<span style="font-size: 1.5rem; color: #000000;">{{realHashrate}}</span>
											<span
												style="color: rgb(153, 153, 153);font-size: 14px;">{{realHashrateUnit}}</span>
										</center>
									</li>
									<li class="card-li">
										<center>
											<span style="font-size: 1.5rem; color: #000000;">{{averageHashrate}}</span>
											<span
												style="color: rgb(153, 153, 153);font-size: 14px;">{{averageHashrateUnit}}</span>
										</center>
									</li>
								</ul>





								<ul style="margin-top: 10px;">
									
									<li class="card-li">
										<center >
											{{$t('labseth.eachEarn')}}
										</center>
									
										<center>
											<span style="font-size: 1.5rem; color: #000000;">{{unitreturn}}</span>
											<span
												style="color: rgb(153, 153, 153);font-size: 14px;">ETC</span>
										</center>
									</li>
									
									<!-- <li class="card-li">
										<center>
											 &nbsp;

										</center>
									</li> -->
								</ul>


								<!-- <ul> -->
									<!-- <li class="card-li"> -->
									<!-- <center>
										<span style="font-size: 1.5rem; color: #000000;">{{unitreturn}}</span>
										<span
											style="color: rgb(153, 153, 153);font-size: 14px;">ETC</span>
									</center> -->
									<!-- </li> -->

									<!-- <li class="card-li">
										<center>
											<span style="font-size: 1.5rem; color: #000000;" > &nbsp;</span>
											<span style="color: rgb(153, 153, 153);font-size: 14px;"
												> &nbsp;</span>
										</center>
									</li> -->
								<!-- </ul> -->




								<div style="margin-bottom: -15px;">
									&nbsp;
								</div>


							</el-card>
						</div>
					</el-col>
					<el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
						<div class="grid-content">
							<el-card class="box-card" style="padding-bottom: 15px;">
								<div slot="header" class="clearfix">
									<span style="font-size: 18px;">{{$t('labseth.totalshare')}}</span>
									<!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
								</div>
								<ul style="padding-bottom: 15px;">
									<li class="card-li">
										<!-- <center> -->
										<div style="width: 70%; margin: auto;" id="hashcharts" class="echarts">
											<div id="share-charts" style="height: 150px;"></div>
										</div>
										<!-- </center> -->
									</li>
									<li class="card-li">
										<ul style="margin-top: 10%;">
											<li>
												<span
													style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#55ff00;"></span>
												<span style="font-size: 14px;">{{$t('labseth.Valid')}} <strong
														style="color: #000000;">{{percent_validShares}}%</strong>
													{{formatterShare(total_validShares)}} </span>
											</li>
											<li style="margin-top: 8px;">
												<span
													style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#fca800;"></span>
												<span style="font-size: 14px;">{{$t('labseth.Stale')}} <strong
														style="color: #000000;">{{percent_staleShares}}%</strong>
													{{formatterShare(total_staleShares)}} </span>
											</li>
											<li style="margin-top: 8px;">
												<span
													style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#ff0000;"></span>
												<span style="font-size: 14px;">{{$t('labseth.Invalid')}} <strong
														style="color: #000000;">{{percent_invalidShares}}%</strong>
													{{formatterShare(total_invalidShares)}} </span>
											</li>
										</ul>

									</li>
								</ul>


							</el-card>
						</div>
					</el-col>

					<el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
						<div class="grid-content">
							<el-card class="box-card" style="padding-bottom: 15px;">
								<div slot="header" class="clearfix">
									<span style="font-size: 18px;">{{$t('labseth.miners')}}</span>
									<!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
								</div>
								<ul style="margin-top: 30px;">
									<li class="card-li">

										<span
											style="font-size: 0.9rem; color: #000000;">{{$t('labseth.online')}}:{{total_online}}</span>
										<!-- <span style="color: rgb(153, 153, 153);font-size: 14px;">KH/s</span> -->

									</li>
									<li class="card-li" style="text-align: right;">

										<span
											style="font-size: 0.9rem; color: #000000;">{{$t('anonminer.offline')}}:{{total_offline}}</span>
										<!-- <span style="color: rgb(153, 153, 153);font-size: 14px;"
												id="rawUnit">KH/s</span> -->

									</li>
								</ul>
								<ul>
									<li>
										<el-progress style="width: 100%;margin-top: 65px;" :percentage="minerpercentage"
											:show-text="false" :color="customColors"></el-progress>
									</li>
								</ul>
								<div style="margin-bottom: 38px;">
									&nbsp;
								</div>
							</el-card>
						</div>
					</el-col>
				</el-row>

				<br>

				<el-tabs v-model="activeName_1" @tab-click="handleClick">
					<!-- <center><el-progress :percentage="refreshNum" status="success"></el-progress></center> -->
					<!-- <center><el-tag  type="danger" effect="dark" size="medium">{{60-refreshNum}}秒后刷新</el-tag></center> -->
					<!-- <center><span id="">
						{{60-refreshNum}}秒后刷新
					</span></center>
					<br> -->

					<el-tab-pane name="first" v-if="isShow1"><span slot="label">{{$t('labseth.miner')}}
							<el-badge class="mark" :value="total_online" />
						</span>
						<div
							style=" width: 100%; margin: 0px auto 0px auto; background-color: white;border-radius: 5px;">
							<el-tabs v-model="activeName_2" style="padding:15px ;">
								<!-- 在线矿机 -->
								<el-tab-pane name="online">
									<span slot="label"><i class="el-icon-success" style="color: #15e715"></i>
										{{$t('labseth.online')}}({{total_online}})</span>
									<div style="width: 100%;height: 20px;">
										<el-switch style="float: right;right: 0px;margin-bottom: 5px;" v-model="useList"
											@change="chooseuselist()" :active-value="true" :inactive-value="false"
											inactive-color="#ff0000" active-color="#4de700"
											:active-text="$t('labseth.openlist')"
											:inactive-text="$t('labseth.closelist')">
										</el-switch>
									</div>

									<el-table :empty-text="$t('labseth.empty')" v-loading="minerdataloading"
										:data="onlineList.filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase()))"
										:default-sort="{ prop: 'minername', order: 'descending' }" border
										:key="Math.random()" style="width: 100%" :fit='true'>
										<el-table-column :label="$t('anonminer.id')" width="50" align="center"
											prop="id">
											<template slot-scope="scope">
												{{ scope.$index + 1 }}
											</template>
										</el-table-column>
										<el-table-column :resizable="false" :label="$t('anonminer.minername')" sortable
											align="center" prop="name"></el-table-column>
										<el-table-column :resizable="false" :label="$t('anonminer.lts')" sortable
											align="center" prop="lts">
											<template slot-scope="scope">
												{{ dateformat(scope.row.lastShare)}}
											</template>
										</el-table-column>
										<el-table-column :resizable="false" :label="$t('labseth.realtimehash')" sortable
											align="center" prop="hash">
											<template slot-scope="scope">
												{{ formatter2(scope.row.hashrate)}}
											</template>
										</el-table-column>
										<!-- <el-table-column :resizable="false" :label="$t('anonminer.validshares')"
											sortable align="center" prop="validShares"></el-table-column>
										<el-table-column :resizable="false" :label="$t('anonminer.invalidshares')"
											sortable align="center" prop="invalidShares"></el-table-column>
										<el-table-column :resizable="false" :label="$t('labseth.stale')" align="center"
											prop="staleShares"></el-table-column> -->
										<el-table-column :resizable="false" align="center">
											<template slot="header" slot-scope="scope">
												<el-input v-model="search" size="mini"
													:placeholder="$t('anonminer.input_search_miner')" />
											</template>
											<template slot-scope="scope">
												<span style="color: #00d000;">{{$t('labseth.online')}}</span>
											</template>
										</el-table-column>
									</el-table>
									<div class="paginationClass" style="width:70%;margin:auto;">
										<el-pagination style="float: right;margin-top: 15px;margin-bottom: 20px;"
											@size-change="onlineSizeChange1" @current-change="onlineCurrentChange1"
											:current-page="onlinecurrentPage" :page-sizes="[5, 10, 15, 20]"
											:page-size="onlinepageSize" layout="total, sizes, prev, pager, next, jumper"
											:total="total_online">
										</el-pagination>
									</div>
								</el-tab-pane>

								<!-- 离线矿机 -->
								<el-tab-pane>
									<span slot="label"><i class="el-icon-error" style="color: red;"></i>
										{{$t('anonminer.offline')}}({{total_offline}})</span>
									<el-table :empty-text="$t('labseth.empty')" v-loading="minerdataloading"
										:data="offlineminer.filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase()))"
										:default-sort="{ prop: 'pay', order: 'descending' }" border :key="Math.random()"
										style="width: 100%" :fit='true'>
										<el-table-column :label="$t('anonminer.id')" width="50" align="center"
											prop="id">
											<template slot-scope="scope">
												{{ scope.$index + 1 }}
											</template>
										</el-table-column>
										<el-table-column :resizable="false" :label="$t('anonminer.minername')" sortable
											align="center" prop="name"></el-table-column>
										<el-table-column :resizable="false" :label="$t('anonminer.lts')" sortable
											align="center" prop="lts">
											<template slot-scope="scope">
												{{ dateformat(scope.row.lastShare)}}
											</template>
										</el-table-column>
										<el-table-column :resizable="false" :label="$t('labseth.realtimehash')" sortable
											align="center" prop="hash">
											<template slot-scope="scope">
												{{ formatter2(scope.row.hashrate)}}
											</template>
										</el-table-column>
										<!-- <el-table-column :resizable="false" :label="$t('anonminer.validshares')"
											sortable align="center" prop="validShares"></el-table-column>
										<el-table-column :resizable="false" :label="$t('anonminer.invalidshares')"
											sortable align="center" prop="invalidShares"></el-table-column>
										<el-table-column :resizable="false" :label="$t('labseth.stale')" align="center"
											prop="staleShares"></el-table-column> -->
										<el-table-column :resizable="false" align="center">
											<template slot="header" slot-scope="scope">
												<el-input v-model="search" size="mini"
													:placeholder="$t('anonminer.input_search_miner')" />
											</template>
											<template slot-scope="scope">
												<span style="color: red;">{{$t('anonminer.offline')}}</span>
											</template>
										</el-table-column>
									</el-table>
									<!-- <div class="paginationClass" style="width:70%;margin:auto;">
										<el-pagination style="float: right;margin-top: 15px;margin-bottom: 20px;"
											@size-change="echartsSizeChange2" @current-change="echartsCurrentChange2"
											:current-page="echartscurrentPage2" :page-sizes="[5, 10, 15, 20, 50,100]"
											:page-size="echartspageSize2"
											layout="total, sizes, prev, pager, next, jumper" :total="total4">
										</el-pagination>
									</div> -->
									<div class="paginationClass" style="width:70%;margin:auto;">
										<el-pagination style="float: right;margin-top: 15px;margin-bottom: 20px;"
											@size-change="offlineSizeChange1" @current-change="offlineCurrentChange1"
											:current-page="offlinecurrentPage" :page-sizes="[5, 10, 15, 20]"
											:page-size="offlinepageSize"
											layout="total, sizes, prev, pager, next, jumper" :total="total_offline">
										</el-pagination>
									</div>
								</el-tab-pane>

							</el-tabs>

						</div>


					</el-tab-pane>

					<el-tab-pane :label="$t('labseth.earning')" name="second" v-if="isShow2">
						<div class="content-earning">

							<el-collapse accordion v-model="earning">
								<el-collapse-item name="1">
									<template slot="title">
										<span class="earning-title">{{$t('labseth.minedisc')}}</span>
									</template>
									<el-row :gutter="10">
										<el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="6">
											<div class="earning-content">
												<center><label>{{$t('labseth.earnmodel')}}</label><br><span>PPS+</span>
												</center>
											</div>
										</el-col>
										<el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="6">
											<div class="earning-content">
												<center><label>{{$t('labseth.fee')}}</label><br><span>0%</span>
												</center>
											</div>

										</el-col>
										<el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="6">
											<div class="earning-content">
												<center><label>{{$t('labseth.intoaccount')}}</label>
													<el-tooltip class="item" effect="dark"
														:content="$t('labseth.intoaccountdisc')" placement="top-start">
														<i class="el-icon-question"></i>
													</el-tooltip>
													<br><span>T+0</span>
												</center>
											</div>

										</el-col>
										<el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="6">
											<div class="earning-content">
												<center>
													<label>{{$t('labseth.support')}}</label><br><span>ETC</span>
												</center>
											</div>
										</el-col>
									</el-row>
								</el-collapse-item>

							</el-collapse>
						</div>
						<div>
						</div>

						<!-- 算力图 -->
						<div class="earning-card">
							<el-card class="box-card">
								<div slot="header" class="clearfix">
									<span>{{$t('labseth.hashcharts')}}</span>

								</div>
								<div style="width: 100%;" id="hashcharts" class="echarts">
									<div id="hashrate-realtime" style="height: 290px;"></div>
								</div>
							</el-card>
						</div>


						<!-- 时时收益 -->
						<!-- 						<div class="earning-card">
							<el-card class="box-card">
								<div slot="header" class="clearfix">
									<span>{{$t('labseth.realearn')}}</span>

								</div>
								<div style="width: 100%;" id="hashcharts" class="echarts">
									<div id="earning-realtime"></div>
								</div>
							</el-card>
						</div> -->



					</el-tab-pane>

					<el-dialog :title="$t('labseth.bindgoogle')" :visible.sync="optshow" :modal="false"
						:width="addpaymentaccountDialogWidth" :close-on-click-modal="false"
						:close-on-press-escape="false" center>
						<div>
							<el-alert :title="$t('labseth.googledisc')" center :closable="false" type="warning"
								show-icon>
							</el-alert>
							<div id="" style="margin-top: 15px;">
								<el-steps direction="vertical" :active="3">
									<el-step :title="$t('labseth.step1')">
										<template slot="description">
											<br />
											<span style="font-size: 14px;color: #65707e">
												{{$t('labseth.step1disc')}}
											</span><br><br>
											<center>
												<el-row :gutter="20">
													<el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
														<a href="https://itunes.apple.com/us/app/google-authenticator/id388497605?mt=8"
															target="_blank"><img src="../../../img/app_store.svg"
																width="100%" /></a>
													</el-col>
													<el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
														<a href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2"
															target="_blank"><img src="../../../img/google_play_.svg"
																width="100%" /></a>
													</el-col>

												</el-row>
											</center>
											<br /><br />

										</template>
									</el-step>
									<el-step :title="$t('labseth.step2')">
										<template slot="description">
											<br />
											<span style="font-size: 14px;color: #65707e">
												{{$t('labseth.step2disc')}}
											</span>
											<br />
											<center>
												<vue-qr :logo-src="logoSrc" :size="191" :margin="0" :auto-color="true"
													:dot-scale="1" :text="optSrc" />
												<br />
												<span style="color: #000000;font-size: 1.125rem;">
													{{optkey}}
												</span>

												<i slot="suffix" class="el-icon-copy-document copyButton"
													style="cursor:pointer;font-size: 1.125rem;"
													:data-clipboard-text="optkey" @click="copykey"></i>



											</center>
											<br />
											<el-alert :title="$t('labseth.googeldisc2')" type="warning" center
												:closable="false">
											</el-alert>

										</template>

										<br /><br /><br /><br />
									</el-step>
									<el-step :title="$t('labseth.step3')">
										<template slot="description">
											<el-form :model="google" ref="google" :rules="optrules">
												<el-form-item :label="$t('labseth.googelcode')" prop="opt">
													<el-input type="opt" :placeholder="$t('labseth.googlecodetip')"
														v-model="google.opt" maxlength="6" show-word-limit
														autocomplete="off">
													</el-input>
												</el-form-item>
												<el-form-item>
													<center>
														<el-button style="width: 100%;" type="primary"
															@click="submitopt">{{$t('labseth.googelcodeconfirm')}}
														</el-button>
													</center>
												</el-form-item>
											</el-form>
										</template>
									</el-step>
								</el-steps>
							</div>

						</div>

					</el-dialog>

					<el-dialog :title="$t('labseth.addpaymentaccount')" :visible.sync="addpaymentaccountDialog"
						:width="addpaymentaccountDialogWidth" :close-on-click-modal="false" :modal="false"
						:destroy-on-close="true" center>
						<center>
							<span style="color: red;" v-if="userStatus===-2">
								{{$t('labseth.paymentaccounttip')}}
								<el-link :underline="false" @click="optshow=true">{{$t('labseth.clickmetobind')}}
								</el-link>
							</span>

						</center>
						<el-form ref="addPaymentAccountForm" :model="addPaymentAccountForm" :rules="usdtrules"
							label-width="80px">
							<center style="color: red;font-size: 14px;">
								<span v-if="addPaymentAccountForm.type==='2'">
									{{$t('labseth.biantip')}}
								</span>
								<span v-if="addPaymentAccountForm.type==='0'">
									{{$t('labseth.usdttip')}}
								</span>
								<span v-if="addPaymentAccountForm.type==='1'">
									{{$t('labseth.alipaytip')}}
								</span>
								<span v-if="addPaymentAccountForm.type==='3'">
									{{$t('labseth.okextip')}}
								</span>
							</center>
							<el-form-item :label="$t('labseth.addtype')">
								<el-select v-model="addPaymentAccountForm.type"
									:placeholder="$t('labseth.selectaddtype')" style="width: 100%;">
									<el-option label="USDT-[TRC20]" value=0></el-option>
									<el-option label="ETH-[BSC]" value=2></el-option>
									<el-option label="ETH-[OKEX]" value=3></el-option>
									<el-option label="Alipay-[CNY]" value=1></el-option>
								</el-select>
							</el-form-item>
							<el-form-item :label="$t('labseth.key8')" prop="account"
								v-if="addPaymentAccountForm.type==='1'">
								<el-input maxlength="8" v-model="addPaymentAccountForm.account"></el-input>
							</el-form-item>
							<el-form-item :label="$t('labseth.accountaddress')" v-else>
								<el-input v-model="addPaymentAccountForm.account"
									v-if="addPaymentAccountForm.type==='0'"></el-input>
								<el-input v-model="addPaymentAccountForm.account" value="1"
									v-if="addPaymentAccountForm.type==='1'"></el-input>
								<el-input v-model="addPaymentAccountForm.account"
									v-if="addPaymentAccountForm.type==='2'"></el-input>
								<el-input v-model="addPaymentAccountForm.account"
									v-if="addPaymentAccountForm.type==='3'"></el-input>
							</el-form-item>
							<el-form-item :label="$t('labseth.alias')" v-if="addPaymentAccountForm.type==='1'">
								<el-input v-model="addPaymentAccountForm.name"></el-input>
							</el-form-item>
							<el-form-item :label="$t('labseth.accountalias')" v-else>
								<el-input v-model="addPaymentAccountForm.name"></el-input>
							</el-form-item>

							<el-form-item>

								<el-button type="primary" v-if="userStatus===-2" disabled>{{$t('labseth.nowadd')}}
								</el-button>
								<el-button type="primary" v-if="userStatus===0"
									@click="openGoogleOPT('onSubmitPaymentAccount')">{{$t('labseth.nowadd')}}
								</el-button>
								<el-button @click="addpaymentaccountDialog = false">{{$t('labseth.cancel')}}</el-button>
							</el-form-item>
						</el-form>
						<!-- <span slot="footer" class="dialog-footer">
					    <el-button @click="addpaymentaccountDialog = false" size="medium">取 消</el-button>
					    <el-button type="primary" size="medium" @click="addpaymentaccountDialog = false">确 定</el-button>
					  </span> -->
					</el-dialog>

					<el-tab-pane :label="$t('labseth.tixian')" name="third" v-if="isShow3">
						<div class="withdrawal-content">

							<el-row :gutter="10">
								<el-col :xs="24" :sm="24" :md="11" :lg="11" :xl="11">
									<el-card class="withdrawal-content-card">
										<div slot="header" class="clearfix">
											<span>{{$t('labseth.paymentoption')}}</span>
											<!-- 											<el-button style="float: right; padding: 3px 0"
												@click="addpaymentaccountDialog = true" type="text">
												{{$t('labseth.addpaymentorderaccount')}}
											</el-button> -->
										</div>
										<div class="withdrawal-content-card-form">
											<center>
												<!-- 												<span style="color: red;" v-if="userStatus===-2">
													{{$t('labseth.paymenttipwithgoogle')}}
													<el-link :underline="false" @click="optshow=true">
														{{$t('labseth.clickmetobind')}}
													</el-link>
												</span>
												<br />
												<span style="color: red;" v-if="addPaymentOrderForm.payType==='0'">
													{{$t('labseth.usdtsdisc1')}}<br>
													{{$t('labseth.usdtsdisc2')}}
												</span>
												<span style="color: red;" v-if="addPaymentOrderForm.payType==='2'">
													{{$t('labseth.ethdisc1')}}<br />
													{{$t('labseth.ethdisc2')}}<br />
													{{$t('labseth.ethdisc4')}}
												</span>
												<span style="color: red;" v-if="addPaymentOrderForm.payType==='1'">
													{{$t('labseth.selectkey')}}<br />

													{{$t('labseth.alipaydisc')}}
												</span>
												<span style="color: red;" v-if="addPaymentOrderForm.payType==='3'">
													{{$t('labseth.okexdisc1')}}<br />
												
													{{$t('labseth.ethdisc4')}}
												</span> -->
												<span style="color: red;" >
													{{$t('labseth.walletTip3')}}
												</span>
											</center>
											<el-form label-position="right" label-width="80px" :model="threshold">
												<el-form-item label="提现阈值">
													<el-input v-model="threshold.threshold">
														<el-button style="padding-right:10px" slot="suffix" type="text"
															@click="changethreshold">修改</el-button>

													</el-input>

												</el-form-item>
												<el-form-item label="提现地址">
													<!-- 	    <el-input v-model="threshold.address">
													 <template slot="append"><el-button type="primary" @click="submitthreshold">修改</el-button></template>
													</el-input> -->
													<el-input v-model="threshold.address" >
														<el-button style="padding-right:10px" slot="suffix" type="text"
															@click="changewalletaddress">修改</el-button>
													</el-input>
												</el-form-item>

											</el-form>
										</div>
									</el-card>
								</el-col>
								<el-col :xs="24" :sm="24" :md="13" :lg="13" :xl="13">
									<el-card class="withdrawal-content-card-2">
										<div slot="header" class="clearfix">
											<span>{{$t('labseth.paymenthistory')}}</span>
										</div>
										<div class="withdrawal-content-card-table">
											<el-table
												:data="paymentOrderList.filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase()))"
												style="width: 100%" fit>
												<el-table-column :label="$t('labseth.date')" prop="time">
													<template slot-scope="scope">
														<span
															style="margin-left: 10px">{{scope.row.datePaid*1000 | formatDate}}</span>
													</template>
												</el-table-column>
												<el-table-column :label="$t('labseth.money')" prop="amount">
													<template slot-scope="scope">
														<span style="margin-left: 10px">{{formatEthBalance(scope.row.amount)}}</span>
													</template>
												</el-table-column>
												
												
												
												<el-table-column :label="$t('labseth.address')" prop="address">
													<template slot-scope="scope">
														<span>{{scope.row.address.substr(0,8)+'****'+scope.row.address.substr(38,43)}}</span>
													</template>
												</el-table-column>

												<el-table-column :label="$t('labseth.txhash')" prop="address">
													<template slot-scope="scope">
														<!-- <el-link type="primary" href={{scope.row.hash}}>主要链接</el-link> -->
														<el-link type="primary" :underline="false" target="_balck"
															:href="'https://blockscout.com/etc/mainnet/tx/'+scope.row.hash">
															{{$t('labseth.gohash')}}
														</el-link>
													</template>
												</el-table-column>
											</el-table>
										</div>
									</el-card>


								</el-col>
							</el-row>
						</div>
					</el-tab-pane>

					<el-tab-pane name="fourth" v-if="isShow4" :label="$t('labseth.minersetting')">
						<div class="quick-start">
							<center style="padding-top: 15px;"><span
									style="margin-top: 15px; font-size: 30px;">TCP{{$t('labseth.nodeaddress')}}etc.starmap.asia:5521<br>
									SSL{{$t('labseth.nodeaddress')}}etc.starmap.asia:5351</span>
								<br><span style="color: red ;">{{$t('labseth.nodetip')}}</span>
							</center>
							<p></p>

							<div
								style="width: 70%; margin: 20px auto; background-color: #fff3e0; padding: 10px 10px 10px 10px; border-radius: 3px;">
								<h3>{{$t('labseth.t_rex')}}
									<el-link type="primary"
										href="https://github.com/C3Pool/software/releases/download/0.02/t-rex.zip"
										target="_blank">{{$t('labseth.down')}}</el-link>
								</h3>
								<span style="color: red;">(TCP)</span><span style="font-size: 16px;">
									t-rex.exe -a etchash -o stratum+ssl://etc.starmap.asia:5351 -u {{$t('labseth.minername')}}.{{$t('labseth.minname')}}
								</span><br>
								<span style="color: red;">(SSL)</span><span style="font-size: 16px;">
									t-rex.exe -a etchash -o stratum+tcp://etc.starmap.asia:5521 -u {{$t('labseth.minername')}}.{{$t('labseth.minname')}}
								</span>
							</div>

						<!-- 	<div
								style="width: 70%; margin: 20px auto; background-color: #fff3e0; padding: 10px 10px 10px 10px; border-radius: 3px;">
								<h3>{{$t('labseth.phoexminer')}}
									<el-link type="primary"
										href="https://github.com/C3Pool/software/releases/download/0.02/PhoenixMiner.zip"
										target="_blank">{{$t('labseth.down')}}</el-link>
								</h3>
								<span style="color: red;">(TCP)</span><span style="font-size: 16px;">
									PhoenixMiner.exe -pool tcp.starmap.asia:43321 -wal {{$t('labseth.minername')}}
									-worker {{$t('labseth.minname')}}
								</span><br>
								<span style="color: red;">(SSL)</span><span style="font-size: 16px;">
									PhoenixMiner.exe -pool ssl://ssl.starmap.asia:54722 -wal {{$t('labseth.minername')}}
									-worker {{$t('labseth.minname')}}
								</span>
							</div> -->

							<div
								style="width: 70%; margin: 20px auto; background-color: #fff3e0; padding: 10px 10px 10px 10px; border-radius: 3px;">
								<h3>{{$t('labseth.nbminer')}}
									<el-link type="primary"
										href="https://github.com/C3Pool/software/releases/download/0.02/NBMiner.zip"
										target="_blank">{{$t('labseth.down')}}</el-link>
								</h3>
								<span style="color: red;">(TCP)</span><span style="font-size: 16px;">
									nbminer -a etchash -o stratum+tcp://etc.starmap.asia:5521 -u {{$t('labseth.minername')}}.{{$t('labseth.minname')}}
								</span><br>
								<span style="color: red;">(SSL)</span><span style="font-size: 16px;">
									nbminer -a etchash -o stratum+ssl://etc.starmap.asia:5351 -u {{$t('labseth.minername')}}.{{$t('labseth.minname')}}
								</span>
							</div>

							<div
								style="width: 70%; margin: 20px auto; background-color: #fff3e0; padding: 10px 10px 10px 10px; border-radius: 3px;">
								<h3>{{$t('labseth.gminer')}}
									<el-link type="primary"
										href="https://github.com/C3Pool/software/releases/download/0.02/gminer.zip"
										target="_blank">{{$t('labseth.down')}}</el-link>
								</h3>
								<span style="color: red;">(TCP)</span><span style="font-size: 16px;">
									miner.exe --algo etchash --server etc.starmap.asia:5521  --user {{$t('labseth.minername')}}.{{$t('labseth.minname')}}
								</span><br>
								<span style="color: red;">(SSL)</span><span style="font-size: 16px;">
									miner.exe --algo etchash --server etc.starmap.asia:5351  --user {{$t('labseth.minername')}}.{{$t('labseth.minname')}} --ssl 1
									
								</span>
							</div>

							<div
								style="width: 70%; margin: 20px auto; background-color: #fff3e0; padding: 10px 10px 10px 10px; border-radius: 3px;">
								<h3>{{$t('labseth.teamredminer')}}
									<el-link type="primary"
										href="https://github.com/C3Pool/software/releases/download/0.02/teamredminer.zip"
										target="_blank">{{$t('labseth.down')}}</el-link>
								</h3>
								<span style="color: red;">(TCP)</span><span style="font-size: 16px;">
									teamredminer.exe -a etchash -o stratum+tcp://etc.starmap.asia:5521 -u {{$t('labseth.minername')}}.{{$t('labseth.minname')}}
								</span><br>
								<span style="color: red;">(SSL)</span><span style="font-size: 16px;">
									teamredminer.exe -a etchash -o stratum+ssl://etc.starmap.asia:5351 -u {{$t('labseth.minername')}}.{{$t('labseth.minname')}}
								</span>
							</div>
							<br>


						</div>
					</el-tab-pane>

					<!-- 					<el-tab-pane name="fifth" v-if="isShow5" :label="$t('labseth.accountmanager')">
						<div class="quick-start">
							<center>
								<div style="width: 85%; padding-top: 20px; padding-bottom: 20px;">


									<el-table :data="paymentaccountList" style="width: 100%" border>

										<el-table-column prop="type" :label="$t('labseth.accounttype')">
											<template
												slot-scope="scope">{{ checkaccounttype(scope.row.type) }}</template>
										</el-table-column>
										<el-table-column prop="account" :label="$t('labseth.accountaddress')">
										</el-table-column>
										<el-table-column prop="name" :label="$t('labseth.accountname')">
										</el-table-column>
										<el-table-column fixed="right" :label="$t('labseth.accounttype')" width="60">
											<template slot-scope="scope">
												<el-button @click="openGoogleToDeleteAccount(scope.row.id)" type="text"
													size="small">
													{{$t('labseth.accountremove')}}
												</el-button>
											</template>
										</el-table-column>
									</el-table>
								</div>




							</center>
						</div>
					</el-tab-pane> -->
				</el-tabs>
			</div>
		</div>

	</div>
</template>

<script>
	var axios = require('axios');
	var qs = require('qs');
	import * as echarts from 'echarts';
	import VueQr from 'vue-qr';
	import Clipboard from 'clipboard';
	import {
		Loading
	} from 'element-ui';
	export default {
		components: {
			VueQr,
		},
		data() {
			var valiopt2 = (rule, value, callback) => {
				let reg = /^[0-9]+$/
				if (value === '') {
					callback(new Error($t('labseth.input')));
				} else if (!reg.test(value)) {
					callback(new Error($t('labseth.codeerr')));
				} else {
					callback();
				}
			};
			var valiopteth = (rule, value, callback) => {
				let reg = /^(0x)?[0-9a-fA-F]{40}$/
				if (value === '') {
					callback(new Error($t('labseth.inputeth')));
				} else if (!reg.test(value)) {
					callback(new Error($t('labseth.addresserr')));
				} else {
					callback();
				}
			};
			var key8 = (rule, value, callback) => {
				// value=this.a.email
				const mailReg = /^[A-Za-z0-9]+$/


				setTimeout(() => {
					if (mailReg.test(value)) {
						callback()
					} else {
						callback(new Error($t('labseth.alipaykeyerr')))
					}
				}, 100)
			}
			return {

				url: this.$global.url, //"https://api.starmap.stream" http://127.0.0.1:8083
				minerid: 2,
				ETH_MULTIPLIER: 1000000000000000000,
				minerdataloading: true,
				token: "",
				userStatus: -2,
				allminer: [],
				onlineminer: [],
				offlineminer: [],
				total_offline: 0,
				total_online: 0,
				activeName_1: "second",
				activeName_2: "online",
				offlineloading: true,
				search: '',
				earning: "1",
				option: {},
				myChart: null,
				hashChart: null,
				hashChartOption: {},
				paymentOrderList: [],
				isShow1: true,
				isShow2: true,
				isShow3: true,
				isShow4: true,
				isShow5: true,
				threshold: {
					threshold: "0.5000",
					address: ""
				},
				addPaymentOrderForm: {
					minerId: this.minerid,
					payType: '',
					usdt: 0.00,
					paymentAccount: '',
					money: 0.0,
					name: '',
					money2: 0.0,
					usdt2: 0.0,
					eth: 0.0
				},
				addpaymentaccountDialog: false,
				addpaymentaccountDialogWidth: "100%",
				addPaymentAccountForm: {
					minerid: this.minerid,
					type: '',
					account: '',
					name: '',
				},
				addPaymentAccountrules: {},
				addPaymentOrderrules: {},
				optshow: false,
				logoSrc: "",
				optSrc: "",
				optkey: "",
				google: {
					opt: ''
				},
				echangeMiner: false,
				minerList: [],
				minerData: {
					"id": 0,
					"user_id": 0,
					"miner_name": "",
					"eth_balance": "0",
					"etc_balance": "0.0000",
					"frozen_capital": "0",
					"remark": null
				},
				addminerdialog: false,
				mineraccount: {
					minerName: '',
					remark: ''
				},
				ethPrice: {
					"eth2cny": 0,
					"eth2usdt": 0,
					"usdt2cny": 0,
					"etc2eth": 0,
					"etc2usdt": 0,

				},
				paymentaccountList: [],
				paymentAccount: {
					usdt: [],
					eth: [],
					zfb: [],
					oken: []
				},
				AccountList: [],
				optRes: false,
				optrules: {
					opt: [{
						validator: valiopt2,
						trigger: 'blur'
					}]
				},
				usdtrules: {
					wallet: [{
						validator: valiopteth,
						trigger: 'blur'
					}],
					account: [{
						validator: key8,
						trigger: 'blur'
					}]
				},
				refreshNum: 0,
				onlinepageSize: 10,
				offlinepageSize: 10,
				onlinecurrentPage: 1,
				offlinecurrentPage: 1,
				onlineList: [],
				offlineList: [],
				alipayCNY: " ≈ 0 CNY",
				subusdt: " ≈ 0 USDT",
				fullscreenLoading: false,
				useList: true,
				lastdayEarning: 0,
				todayearn: 0,
				isobserver: false,
				observerurl: "",
				sharecharts: null,
				customColors: [{
						color: '#ff0000',
						percentage: 20
					},
					{
						color: '#ffaa00',
						percentage: 40
					},
					{
						color: '#ffaa00',
						percentage: 60
					},
					{
						color: '#5cb87a',
						percentage: 80
					},
					{
						color: '#5cb87a',
						percentage: 100
					}
				],
				minerpercentage: 100,
				showtext: false,
				percent_validShares: 0,
				percent_staleShares: 0,
				percent_invalidShares: 0,
				total_validShares: 0,
				total_staleShares: 0,
				total_invalidShares: 0,
				averageHashrate: "0",
				averageHashrateUnit: "H/s",
				realHashrate: "0",
				realHashrateUnit: "H/s",
				total_hash: 0,
				total_hashUnit: "",
				shownotice: false,
				realname: "",
				tixiancount: 10,
				loading: null,
				exchangeeth: " ≈ 0 ETH",
				googelcode1: 0,
				unitreturn:0
			}
		},
		watch: {
			'addPaymentOrderForm.payType': {
				handler(newName, oldName) {

					if (newName === "1") { //cny
						// this.addPaymentOrderForm.money2=this.fix2(this.ethPrice.eth2cny*this.formatEthBalance(this.minerData.eth_balance))
						this.addPaymentOrderForm.usdt2 = this.formatEthBalance(this.minerData.etc_balance)
						this.AccountList = this.paymentAccount.zfb
					} else if (newName === "2") { //eth
						this.addPaymentOrderForm.usdt2 = this.formatEthBalance(this.minerData.etc_balance)
						this.AccountList = this.paymentAccount.eth
					} else if (newName === "3") { //eth
						// this.exchangeeth=""
						this.addPaymentOrderForm.usdt2 = this.formatEthBalance(this.minerData.etc_balance)
						this.AccountList = this.paymentAccount.okex
						// console.log(this.AccountList)
					} else if (newName === "0") { //usdt
						// this.addPaymentOrderForm.usdt2=this.fix2(this.ethPrice.eth2usdt*this.formatEthBalance(this.minerData.eth_balance))
						this.addPaymentOrderForm.usdt2 = this.formatEthBalance(this.minerData.etc_balance)
						this.AccountList = this.paymentAccount.usdt
					}
				}
			},

		},
		filters: {
			formatDate: function(value) {
				let date = new Date(value);
				let y = date.getFullYear();
				let MM = date.getMonth() + 1;
				MM = MM < 10 ? ('0' + MM) : MM;
				let d = date.getDate();
				d = d < 10 ? ('0' + d) : d;
				let h = date.getHours();
				h = h < 10 ? ('0' + h) : h;
				let m = date.getMinutes();
				m = m < 10 ? ('0' + m) : m;
				let s = date.getSeconds();
				s = s < 10 ? ('0' + s) : s;
				return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
			}
		},
		created() {
			let that = this
			this.token = localStorage.getItem("token")
			this.newinitMiner()
			// console.log(minerid)

			this.option = {
				color: [
					'#55ff00',
					'#c0e7ff',
					'#adebb7',
					'#2f4554',
					'#61a0a8',
					'#91c7ae',
					'#749f83',
					'#bda29a',
					'#6e7074',
					'#546570',
					'#c4ccd3'
				],
				xAxis: {
					type: 'category',
					data: []
				},
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'cross',
						label: {
							backgroundColor: '#6a7985'
						}
					}
				},
				dataZoom: [{
						// startValue: '2014-06-01'
					},
					{
						type: 'inside'
					}
				],
				yAxis: {
					type: 'value'
				},
				series: [{
					data: [],
					type: 'bar'
				}]
			};

			this.hashChartOption = {
				xAxis: {
					type: 'category',
					data: []
				},
				legend: {
					data: ['实时', '平均']
				},
				yAxis: {
					type: 'value',
					axisLabel: {
						formatter: function(value) {
							if (value >= 1 && value < 1000) {
								// texts.push(value + 'H/s')
								return value.toFixed(2) + 'H/s'
							} else if (value >= 1000 && value < 1000000) {
								return (value / 1000).toFixed(2) + 'KH/s'
							} else if (value >= 1000000 && value < 1000000000) {
								return (value / 1000000).toFixed(2) + 'MH/s'
							} else if (value >= 1000000000 && value < 1000000000000) {
								return (value / 1000000000).toFixed(2) + 'GH/s'
							} else if (value >= 1000000000000) {
								return (value / 1000000000000).toFixed(2) + 'TH/s'
							} else if (value == 0) {
								return (0)
							}
						}
					}
				},
				dataZoom: [{
						// startValue: '2014-06-01'
					},
					{
						type: 'inside'
					}
				],
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'cross',
						label: {
							backgroundColor: '#6a7985'
						},
					},
					// formatter: '{b0}<br />{a0}:{c0}<br />{a1}:{c1}%',
					formatter: function(params) {
						return params[0].name + '<br/>' +
							'<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' +
							params[0].color + ';"></span>' +
							params[0].seriesName + ' : ' + that.formatterHash(params[0].value) + '<br/>' +
							'<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' +
							params[1].color + ';"></span>' +
							params[1].seriesName + ' : ' + that.formatterHash(params[1].value);

					}
				},
				series: [{
						name: "实时",
						data: [],
						type: 'line',
						smooth: true
					},
					{
						name: "平均",
						data: [],
						type: 'line',
						smooth: true
					}
				]
			};
			
			this.sharechartsOption = {
				color: ["#4ce600", "#fca800", "#ff0000"],
				tooltip: {
					trigger: 'item',
					position: function(point, params, dom, rect, size) {
						//  size为当前窗口大小
						if ((size.viewSize[0] / 2) >= point[0]) {
							//其中point为当前鼠标的位置
							return [point[0] + 50, '10%'];
						} else {
							//其中point为当前鼠标的位置
							return [point[0] + 50, '10%'];
						}
					}
				},
				series: [{
					name: '提交份额',
					type: 'pie',
					radius: ['100%', '70%'],
					avoidLabelOverlap: false,
					itemStyle: {
						borderRadius: 5,
						borderColor: '#fff',
						borderWidth: 2
					},
					label: {
						show: false,
						position: 'center'
					},
					emphasis: {
						label: {
							show: false,
							fontSize: '40',
							fontWeight: 'bold'
						}
					},
					labelLine: {
						show: false
					},
					data: [{
							itemStyle: "#55ff00",
							value: 1000,
							name: '有效份额'
						},
						{
							itemStyle: "#fca800",
							value: 200,
							name: '延迟份额'
						},
						{
							itemStyle: "#ff0000",
							value: 100,
							name: '无效份额'
						},
					]
				}]
			};


			this.addPaymentOrderrules = {
				payType: [{
					required: true,
					message: '请选择提现类型',
					trigger: 'change'
				}],
				paymentAccount: [{
					required: true,
					message: '请输入提现账户',
					trigger: 'change'
				}],
				money: [{
					required: true,
					message: '请输入提现账户',
					trigger: 'change'
				}]
			}

		},
		async mounted() {
			let that = this
			// await this.initMinerData()
			await this.newinitMiner()
			await this.initMiner()
			 this.initlastdayearn()
			 this.initPaymentOrder()
			 this.checkUserStatus()
			 this.getEthPrice()
			 this.gethashrate()
			// await this.initobserverstatus()
			// this.initPaymentHistoryCharts()
			this.initHashrateCharts()
			 this.initsharedata()
			this.initthreshold()
			this.initunitreturn()
			this.addPaymentOrderForm.usdt2 = this.formatEthBalance(this.minerData.etc_balance)
			this.addPaymentOrderForm.minerId = this.minerid
			this.addPaymentAccountForm.minerid = this.minerid


			// var fwidth=document.getElementById('fcharts').offsetWidth+'px'
			// document.getElementById('earning-realtime').style.width=fwidth

			// window.addEventListener("resize", this.chartResize);
			//window.addEventListener('touchmove', handler, { passive: false})；
			let width1 = document.body.clientWidth
			if (width1 < 768) {
				that.addpaymentaccountDialogWidth = "80%"
			} else if (width1 >= 768 && width1 <= 1200) {
				that.addpaymentaccountDialogWidth = "50%"
			} else {
				that.addpaymentaccountDialogWidth = "30%"
			}
			window.onresize = function() {
				that.myChart.resize();
				that.hashChart.resize();
				that.sharecharts.resize();
				let width1 = document.body.clientWidth
				if (width1 < 768) {
					that.addpaymentaccountDialogWidth = "80%"
				} else if (width1 >= 768 && width1 <= 1200) {
					that.addpaymentaccountDialogWidth = "50%"
				} else {
					that.addpaymentaccountDialogWidth = "30%"
				}
			}
			window.setInterval(function() {

				that.refreshNum = that.refreshNum + 1
				if (that.refreshNum >= 60) {
					that.onlineminer = []
					that.offlineminer = []
					that.total_hash = 0
					that.initMiner()
					that.initHashrateCharts()
					that.initsharedata()
					that.gethashrate()
					that.refreshNum = 0
				}
			}, 1000)
			window.setInterval(function() {
				// that.initMinerData()

				that.newinitMiner()
			}, 1000 * 60 * 10)

			this.observerurl = "https://c3pool.com/observer?miner=" + this.minerData.miner_name
		},

		methods: {
			initunitreturn(){
				let that =this
				var config = {
				  method: 'get',
				  url: this.url+'/lab/getUnitreturn/',
				  headers: {'token': this.token }
				};
				
				axios(config)
				.then(function (response) {
					that.unitreturn=response.data.data.unitreturn
				  // console.log(JSON.stringify(response.data));
				})
				.catch(function (error) {
				  console.log(error);
				});

			},
			initthreshold() {
				let that = this
				var config = {
					method: 'get',
					url: this.url + '/lab/ETCthreshold?name=' + this.minerData.miner_name,
					headers: {
						'token': this.token
					}
				};

				axios(config)
					.then(function(response) {
						// console.log(response.data)
						that.threshold.threshold = response.data.data.threshold
						that.threshold.address = response.data.data.address
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			 changethreshold() {
				 if(this.userStatus===-2){
					 this.checkUserStatus()
					 return
				 }
				
				let that = this
				const h = this.$createElement;
				this.$prompt(that.$t('labseth.googelcodetitle'), { //$t('labseth.googelcodetitle')
					message: h('p', null, [
						h('span', null, that.$t('labseth.googelcodetitle')),
						h('br', null, null),
						h('i', {
							style: 'color: teal'
						}, that.$t('labseth.thresholdTip') + that.threshold.threshold + "ETC"),
						h('br', null, null),
						h('i', {
							style: 'color: red'
						}, that.$t('labseth.thresholdTip2')),
						h('br', null, null)
					]),

					confirmButtonText: that.$t('labseth.confirm'), //$t('labseth.confirm')
					cancelButtonText: that.$t('labseth.cancel'), // $t('labseth.cancel'),
					inputPattern: /^[0-9]+$/,
					inputErrorMessage: that.$t('labseth.coderegerr') //$t('labseth.coderegerr')
				}).then(async ({
					value
				}) => {
					that.submitthreshold(value)
				
				}).catch(() => {
					//取消输入      
				});
			},
			changewalletaddress() {
				if(this.userStatus===-2){
									 this.checkUserStatus()
									 return
				}
				let that = this
				const h = this.$createElement;
				this.$prompt(that.$t('labseth.googelcodetitle'), { //$t('labseth.googelcodetitle')
					message: h('p', null, [
						h('span', null, that.$t('labseth.googelcodetitle')),
						h('br', null, null),
						h('i', {
							style: 'color: teal'
						}, that.$t('labseth.walletTip')+that.threshold.address),
						h('br', null, null),
						h('i', {
							style: 'color: red'
						}, that.$t('labseth.walletTip2')),
						h('br', null, null),
					]),

					confirmButtonText: that.$t('labseth.confirm'), //$t('labseth.confirm')
					cancelButtonText: that.$t('labseth.cancel'), // $t('labseth.cancel'),
					inputPattern: /^[0-9]+$/,
					inputErrorMessage: that.$t('labseth.coderegerr') //$t('labseth.coderegerr')
				}).then(async ({
					value
				}) => {

					that.submitthaddress(value)
					// this.$message({
					//   type: 'success',
					//   message: '你的验证码是: ' + value
					// });
				}).catch(() => {
					//取消输入      
				});
			},
			submitthaddress(value) {
				var config = {
					method: 'get',
					url: this.url + '/lab/setETCWalletAddress?name=' + this.minerData.miner_name + '&address=' + this
						.threshold.address + '&code=' + value,
					headers: {
						'token': this.token
					}
				};
				let that = this
				axios(config)
					.then(function(response) {
						if (response.data.data.res === true) {
							that.$message({
								message: response.data.data.msg,
								type: 'success'
							});
						} else {
							that.$message.error(response.data.msg);
						}
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			submitthreshold(value) {
				var config = {
					method: 'get',
					url: this.url + '/lab/setETCThreshold?name=' + this.minerData.miner_name + '&thresholdValue=' +
						this.threshold.threshold + '&code=' + value,
					headers: {
						'token': this.token
					}
				};
				let that = this
				axios(config)
					.then(function(response) {
						// console.log(JSON.stringify(response.data));
						if (response.data.data.res === true) {
							that.$message({
								message: response.data.data.msg,
								type: 'success'
							});
						} else {
							that.$message.error(response.data.msg);
						}
					})
					.catch(function(error) {
						console.log(error);
					});

			},
			openFullScreen2() {
				this.loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				// loading.close();
			},
			minus() {
				if (this.tixiancount <= 10) {
					this.tixiancount = 10
				} else {
					this.tixiancount = this.tixiancount - 1
				}
			},
			plus() {
				if (this.tixiancount <= 10) {
					this.tixiancount = 10
				} else {
					this.tixiancount = this.tixiancount + 1
				}
			},
			valiCardNo() {
				if (this.addPaymentOrderForm.paymentAccount.length < 19) {
					console.log(this.addPaymentOrderForm.paymentAccount.length)
					this.$message.error('银行卡号长度不足');
				} else if (this.addPaymentOrderForm.paymentAccount.length > 19) {
					this.$message.error('银行卡号长度过长');
				} else if (this.addPaymentOrderForm.paymentAccount.length === 19) {
					var config = {
						method: 'get',
						url: 'https://ccdcapi.alipay.com/validateAndCacheCardInfo.json?_input_charset=utf-8&cardNo=' +
							this.addPaymentOrderForm.paymentAccount + '&cardBinCheck=true',

					};

					axios(config)
						.then(function(response) {
							var bank = response.data.bank
							if (bank === "ICBC" || bank === "ABC" || bank === "CCB" || bank === "BOC") {
								console.log(JSON.stringify(response.data));
								console.log(JSON.stringify(response.data.bank));
							}

						})
						.catch(function(error) {
							console.log(error);
						});

				}
			},
			gethashrate() {
				var config = {
					method: 'get',
					url: this.url + '/lab/getHashate?minername=' + this.minerData.miner_name,
					headers: {
						'token': this.token
					}
				};
				let that = this
				axios(config)
					.then(function(response) {
						that.realtimehash
						var tmp1 = response.data.data.currentHashrate
						var tmp2 = response.data.data.averageHashrate
						tmp1 = that.formatter(tmp1).split("|")
						tmp2 = that.formatter(tmp2).split("|")
						that.realHashrate = tmp1[0]
						that.realHashrateUnit = tmp1[1]
						that.averageHashrate = tmp2[0]
						that.averageHashrateUnit = tmp2[1]
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			formatterShare(value) {
				if (value > 1000 && value < 1000000) {
					return (value / 1000).toFixed(2) + "K"
				} else if (value > 1000000 && value < 1000000000) {
					return (value / 1000000).toFixed(2) + "W"
				} else if (value > 1000000000 && value < 1000000000000) {
					return (value / 1000000000).toFixed(2) + "W"
				} else {
					return value
				}
			},
			initsharedata() {
				let that = this
				var config = {
					method: 'get',
					url: this.url + '/lab/getminershares?minername=' + this.minerData.miner_name + "&type=ETC",
					headers: {
						'token': this.token
					}
				};

				axios(config)
					.then(function(response) {
						var totalshare = response.data.data.validShares + response.data.data.invalidShares

						that.percent_validShares = (response.data.data.validShares / totalshare * 100).toFixed(2)
						that.percent_invalidShares = (response.data.data.invalidShares / totalshare * 100).toFixed(2)
						that.percent_staleShares = (response.data.data.staleShares / totalshare * 100).toFixed(2)


						that.sharechartsOption.series[0].data[0].value = response.data.data.validShares
						that.sharechartsOption.series[0].data[1].value = response.data.data.staleShares
						that.sharechartsOption.series[0].data[2].value = response.data.data.invalidShares
						that.total_validShares = response.data.data.validShares
						that.total_staleShares = response.data.data.staleShares
						that.total_invalidShares = response.data.data.invalidShares
						var chartDom = document.getElementById('share-charts');
						that.sharecharts = echarts.init(chartDom);
						that.sharechartsOption && that.sharecharts.setOption(that.sharechartsOption);
						// console.log(JSON.stringify(response.data));
					})
					.catch(function(error) {
						console.log(error);
					});

			},
			formatterHash(value) {
				if (value >= 1 && value < 1000) {
					// texts.push(value + 'H/s')
					return value.toFixed(2) + 'H/s'
				} else if (value >= 1000 && value < 1000000) {
					return (value / 1000).toFixed(2) + 'KH/s'
				} else if (value >= 1000000 && value < 1000000000) {
					return (value / 1000000).toFixed(2) + 'MH/s'
				} else if (value >= 1000000000 && value < 1000000000000) {
					return (value / 1000000000).toFixed(2) + 'GH/s'
				} else if (value >= 1000000000000) {
					return (value / 1000000000000).toFixed(2) + 'TH/s'
				} else if (value == 0) {
					return (0)
				}
			},
			openobserver() {
				let that = this
				var config = {
					method: 'get',
					url: this.url + '/lab/openObserver?minerid=' + this.minerid + "&type=ETC",
					headers: {
						'token': this.token
					}
				};

				axios(config)
					.then(function(response) {
						if (response.data.data === true) {
							that.$message.success("开启成功")
						} else {
							that.$message.error("开启失败")
						}
					})
					.catch(function(error) {
						that.$message.error("开启失败")
					});

			},
			closeobserver() {
				let that = this
				var config = {
					method: 'get',
					url: this.url + '/lab/closeObserver?minerid=' + this.minerid,
					headers: {
						'token': this.token
					}
				};

				axios(config)
					.then(function(response) {
						if (response.data.data === true) {
							that.$message.success("关闭成功")
						} else {
							that.$message.error("关闭失败")
						}
					})
					.catch(function(error) {
						that.$message.error("关闭失败")
					});

			},
			openorcloseobserver() {
				if (this.isobserver === true) {
					this.openobserver()
				} else {
					this.closeobserver()
				}
				// console.log()
			},
			initobserverstatus() {
				let that = this
				var config = {
					method: 'get',
					url: this.url + '/lab/observerStatus?minerid=' + this.minerid,
					headers: {
						'token': this.token
					}
				};

				axios(config)
					.then(function(response) {
						that.isobserver = response.data.data
					})
					.catch(function(error) {
						console.log(error);
					});

			},
			async newinitMiner() {
				let minerid = this.$urlParse.getUrlKey('minerid');
				if (minerid != null) {
					await this.initAllMiners()

					var flag = false
					for (var item in this.minerList) {

						if (this.minerList[item].id === parseInt(minerid)) {
							this.minerid = parseInt(minerid)

							this.minerData = this.minerList[item]
							flag = true
						}
					}
					if (flag === false) {
						await this.initMinerData()
					}
				} else {
					await this.initMinerData()
				}
			},

			initlastdayearn() {
				var config = {
					method: 'get',
					url: this.url + '/lab/getETCLastDayEarnings?minerid=' + this.minerid + "&type=ETC",
					headers: {
						'token': this.token
					}
				};
				let that = this
				axios(config)
					.then(function(response) {
						that.lastdayEarning = response.data.data.lastDayEarnings
						that.todayearn = response.data.data.toDayEarnings
					})
					.catch(function(error) {
						console.log(error);
					});

			},
			deleteAccountFun(accountid) {
				let that = this
				// console.log(accountid, this.minerid)
				var config = {
					method: 'get',
					url: this.url + '/lab/deletePaymentAccount?accountid=' + accountid + '&minerid=' + this.minerid,
					headers: {
						'token': this.token
					}
				};

				axios(config)
					.then(function(response) {
						if (response.data.data === true) {
							that.$message.success(that.$t('labseth.deletesuccess'))
							that.initPaymentAccount()
						} else {
							that.$message.error(that.$t('labseth.deleteerror'))
						}
						// console.log(JSON.stringify(response.data));
					})
					.catch(function(error) {
						console.log(error);
					});
			},

			checkaccounttype(value) {
				if (value === 0) {
					return "USDT"
				} else if (value === 1) {
					return "Alipay"
				} else if (value === 2) {
					return "ETH(BSC)"
				} else if (value === 3) {
					return "ETH(OEC)"
				} else {
					return this.$t('labseth.unknown')
				}
			},
			chooseuselist() {
				if (!this.useList) {
					// console.log(this.total_online)
					this.onlineSizeChange1(this.total_online)
				} else {
					this.onlineSizeChange1(10)
				}
			},
			changeCNY(target) {
				console.log(this.addPaymentOrderForm)
				console.log(parseFloat(this.addPaymentOrderForm.usdt))
				// console.log(parseFloat(this.minerData.eth_balance))
				if (parseFloat(this.addPaymentOrderForm.usdt) > parseFloat(this.minerData.etc_balance)) {
					this.alipayCNY = this.$t('labseth.balanceinsuf')
				} else {
					this.alipayCNY = this.addPaymentOrderForm.money2 = this.fix2(this.ethPrice.eth2cny * this
						.addPaymentOrderForm.usdt)
					this.alipayCNY = " ≈ " + this.alipayCNY + " CNY"


					this.subusdt = this.fix2(this.ethPrice.etc2usdt * this.addPaymentOrderForm.usdt)
					this.subusdt = " ≈ " + this.subusdt + " USDT"
					this.exchangeeth = this.fix3(this.ethPrice.etc2eth * parseFloat(this.addPaymentOrderForm.usdt))
					// console.log(this.ethPrice.etc2eth,parseFloat(this.addPaymentOrderForm.usdt))
					// console.log(this.exchangeeth)
					this.exchangeeth = " ≈ " + this.exchangeeth + " ETH"
					// console.log(this.exchangeeth)
				}

			},
			calcPaymentOrderRes(value) {
				value = value / this.ETH_MULTIPLIER
				return Math.floor(value * 100000000) / 100000000
			},
			openGoogleOPT(method) {
				// console.log(this.mineraccount)
				let that = this
				// console.log(method)
				this.$prompt(that.$t('labseth.googelcodetitle'), { //$t('labseth.googelcodetitle')
					confirmButtonText: that.$t('labseth.confirm'), //$t('labseth.confirm')
					cancelButtonText: that.$t('labseth.cancel'), // $t('labseth.cancel'),
					inputPattern: /^[0-9]+$/,
					inputErrorMessage: that.$t('labseth.coderegerr') //$t('labseth.coderegerr')
				}).then(async ({
					value
				}) => {
					// let f=false
					await this.validopt(value)
					// console.log("this.optRes2:"+this.optRes)
					if (this.optRes === true) {
						if (method === "onSubmitPayment") {
							// console.log("onSubmitPayment-ing")
							this.onSubmitPayment()
						} else if (method === "onSubmitPaymentAccount") {
							this.onSubmitPaymentAccount()
						} else if (method === "subaddMinerAccount") {
							this.subaddMinerAccount()
						} else {
							this.$message.error(that.$t('labseth.optinerr'))
						}

					} else if (f === false) {
						this.$message({
							type: 'error',
							message: that.$t('labseth.codeerr1')
						});
					} else {
						this.$message({
							type: 'error',
							message: that.$t('labseth.unknown')
						});
					}
					this.optRes = false
					// this.$message({
					//   type: 'success',
					//   message: '你的验证码是: ' + value
					// });
				}).catch(() => {
					//取消输入      
				});
			},
			openGoogleToDeleteAccount(accountid) {
				// console.log(this.mineraccount)
				let that = this
				// console.log(method)
				this.$prompt(that.$t('labseth.googelcodetitle'), { //$t('labseth.googelcodetitle')
					confirmButtonText: that.$t('labseth.confirm'), //$t('labseth.confirm')
					cancelButtonText: that.$t('labseth.cancel'), // $t('labseth.cancel'),
					inputPattern: /^[0-9]+$/,
					inputErrorMessage: that.$t('labseth.coderegerr') //$t('labseth.coderegerr')
				}).then(async ({
					value
				}) => {
					// let f=false
					await this.validopt(value)
					// console.log("this.optRes2:"+this.optRes)
					if (this.optRes === true) {
						this.deleteAccountFun(accountid)

					} else if (f === false) {
						this.$message({
							type: 'error',
							message: that.$t('labseth.codeerr1')
						});
					} else {
						this.$message({
							type: 'error',
							message: that.$t('labseth.unknown')
						});
					}
					this.optRes = false
					// this.$message({
					//   type: 'success',
					//   message: '你的验证码是: ' + value
					// });
				}).catch(() => {
					//取消输入      
				});
			},
			deleteMineraccount(miner) {

			},
			onlineSizeChange1: function(pageSize) {
				// 每页条数切换
				this.onlinepageSize = pageSize;
				this.onlineCurrentChange1(this.onlinecurrentPage);
			},
			onlineCurrentChange1: function(currentPage) {
				//页码切换
				this.onlinecurrentPage = currentPage;
				this.onlinecurrentChangePage(this.onlineminer, currentPage);
			},
			//分页方法（重点）
			onlinecurrentChangePage(list, currentPage) {
				let from = (currentPage - 1) * this.onlinepageSize;
				let to = currentPage * this.onlinepageSize;
				this.onlineList = [];
				for (; from < to; from++) {
					if (list[from]) {
						this.onlineList.push(list[from]);
					}
				}
			},

			offlineSizeChange1: function(pageSize) {
				// 每页条数切换
				this.onlinepageSize = pageSize;
				this.onlineCurrentChange1(this.onlinecurrentPage);
			},
			offlineCurrentChange1: function(currentPage) {
				//页码切换
				this.offlinecurrentPage = currentPage;
				this.offlinecurrentChangePage(this.offlineminer, currentPage);
			},
			//分页方法（重点）
			offlinecurrentChangePage(list, currentPage) {
				let from = (currentPage - 1) * this.offlinepageSize;
				let to = currentPage * this.offlinepageSize;
				this.offlineList = [];
				for (; from < to; from++) {
					if (list[from]) {
						this.offlineList.push(list[from]);
					}
				}
			},
			async initPaymentHistoryCharts() {
				let that = this
				var config = {
					method: 'get',
					url: this.url + '/lab/getPaymentHistory?minerid=' + this.minerid + "&type=ETC",
					headers: {
						'token': this.token
					}
				};

				await axios(config)
					.then(function(response) {
						for (var item in response.data.data) {
							that.option.xAxis.data.unshift(that.dataformater2(response.data.data[item].time))
							that.option.series[0].data.unshift(Math.floor((response.data.data[item].amount / that
								.ETH_MULTIPLIER) * 10000000) / 10000000)
						}
						var chartDom = document.getElementById('earning-realtime');
						that.myChart = echarts.init(chartDom, {
							renderer: 'svg'
						});
						that.option && that.myChart.setOption(that.option);
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			async initHashrateCharts() {
				let that = this
				// var chartDom = document.getElementById('hashrate-realtime');
				// that.hashChart = echarts.init(chartDom, {
				// 	renderer: 'svg'
				// });
				// that.hashChartOption && that.hashChart.setOption(that.hashChartOption);
				var config = {
					method: 'get',
					url: this.url + '/lab/gethistoryhashrate?minername=' + this.minerData.miner_name,
					headers: {
						'token': this.token
					}
				};

				await axios(config)
					.then(function(response) {
						that.hashChartOption.series[0].data = []
						that.hashChartOption.series[1].data = []
						that.hashChartOption.xAxis.data = []
						for (var item in response.data.data) {
							that.hashChartOption.xAxis.data.push(that.dataformater2(response.data.data[item].time ))
							that.hashChartOption.series[0].data.push(parseFloat(response.data.data[item]
								.currentHashrate))
							that.hashChartOption.series[1].data.push(parseFloat(response.data.data[item]
								.averageHashrate))
						}
						// if(response.data.data.length===0){
						// 	that.averageHashrate=0.00
						// 	that.averageHashrateUnit="H/s"
						// }else{
						// 	var temp=response.data.data[response.data.data.length-1].averageHashrate
						// 	temp=that.formatter(temp).split("|")

						// 	that.averageHashrate=temp[0]
						// 	that.averageHashrateUnit=temp[1]

						// 	var temp2=response.data.data[response.data.data.length-1].currentHashrate
						// 	temp2=that.formatter(temp2).split("|")

						// 	that.realHashrate=temp2[0]
						// 	that.realHashrateUnit=temp2[1]

						// }


						// console.log(that.hashChartOption)
						var chartDom = document.getElementById('hashrate-realtime');
						that.hashChart = echarts.init(chartDom, {
							renderer: 'svg'
						});
						that.hashChartOption && that.hashChart.setOption(that.hashChartOption);
					})
					.catch(function(error) {
						console.log(error);
					});

			},


			getOPT() {
				let that = this
				var config = {
					method: 'get',
					url: this.url + '/api/opt',
					headers: {
						'token': this.token
					}
				};

				axios(config)
					.then(function(response) {

						that.optSrc = response.data.data
						let tmp = response.data.data
						that.optkey = tmp.substr(-16, 19)
						// console.log(tmp.substr(-16,19))
					})
					.catch(function(error) {
						console.log(error);
					});

			},
			initPaymentAccount() {
				let that = this
				var config = {
					method: 'get',
					url: this.url + '/lab/getAccount?minerid=' + this.minerid + "&type=ETC",
					headers: {
						'token': this.token
					},

				};

				axios(config)
					.then(function(response) {
						that.paymentAccount.eth = []
						that.paymentAccount.zfb = []
						that.paymentAccount.usdt = []
						that.paymentAccount.okex = []
						for (var item in response.data.data) {
							if (response.data.data[item].type === 0) {
								that.paymentAccount.usdt.unshift(response.data.data[item])
							} else if (response.data.data[item].type === 1) {
								that.paymentAccount.zfb.unshift(response.data.data[item])
							} else if (response.data.data[item].type === 2) {
								that.paymentAccount.eth.unshift(response.data.data[item])
							} else if (response.data.data[item].type === 3) {
								that.paymentAccount.okex.unshift(response.data.data[item])
							}
							that.paymentaccountList = response.data.data
						}
						console.log(response.data);
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			allTixian() {
				console.log(this.addPaymentOrderForm.usdt2)
				if (this.addPaymentOrderForm.payType === "1") {
					// this.addPaymentOrderForm.money=this.addPaymentOrderForm.money2
					this.addPaymentOrderForm.usdt = this.addPaymentOrderForm.usdt2
				} else {
					this.addPaymentOrderForm.usdt = this.addPaymentOrderForm.usdt2
				}
				this.changeCNY()
			},
			fix2(num) {
				return Math.floor(num * 100) / 100
			},
			fix3(num) {
				return Math.floor(num * 100000000) / 100000000
			},
			getEthPrice() {
				let that = this
				var config = {
					method: 'get',
					url: this.url + '/lab/getPrice',
					headers: {
						'token': this.token
					}
				};

				axios(config)
					.then(function(response) {
						that.ethPrice = response.data.data
						// console.log(JSON.stringify(response.data));
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			formatEthBalance(eth) {
				let tmp = eth / this.ETH_MULTIPLIER
				let temp2 = Math.floor(tmp * 100000000) / 100000000
				return temp2
			},
			async subaddMinerAccount() { //提交添加子账户请求
				let that = this

				var data = qs.stringify({
					'minerName': "ar_" + that.mineraccount.minerName,
					'remark': "ar_" + that.mineraccount.remark
				});
				// console.log(data)
				var config = {
					method: 'post',
					url: this.url + '/lab/createEtcSubAccount',
					headers: {
						'token': this.token,
						'Content-Type': 'application/x-www-form-urlencoded'
					},
					data: data
				};

				await axios(config)
					.then(function(response) {
						if (response.data.code === 0) {
							that.addminerdialog = false
							that.$message.success(that.$t('labseth.addsuccess'))
						} else if (response.data.code === 4003) {
							that.$message.error(that.$t('labseth.addexist'))
						} else if (response.data.code === 4002) {
							that.$message.error(that.$t('labseth.loginfail'))
							that.$router.push({
								path: "/login?redirect=/labs/eth-index"
							});
						} else if (response.data.code === 200001) {
							that.$message.error(that.$t('labseth.addtip'))
						}
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			addMinerAccount() {
				this.echangeMiner = false
				this.addminerdialog = true
			},
			chooseminer(info) { //更换子账户
				this.minerData = info
				this.minerid = info.id
				this.echangeMiner = false
				this.mineraccount = []
				this.total_offline = 0
				this.total_online = 0
				// this.myChart=null
				this.addPaymentOrderForm = {
					minerId: this.minerid,
					payType: '',
					usdt: 0.00,
					paymentAccount: '',
					money: 0.0,
					name: '',
					money2: 0.0,
					usdt2: 0.0,
					eth: 0.0
				}
				const newUrl = this.$route.path + "?minerid=" + info.id
				window.history.replaceState('', '', newUrl)
				this.option.series[0].data = []
				this.option.xAxis.data = []
				this.myChart.distory
				// console.log("console.log(this.AccountList)" + this.AccountList)
				this.initobserverstatus()
				this.initMiner()

				this.initPaymentOrder()
				this.initPaymentAccount()

				this.initPaymentHistoryCharts()
				this.observerurl = "https://c3pool.com/observer?miner=" + this.minerData.miner_name

			},
			async initMinerData() { //初始化默认子账户

				let that = this
				var config = {
					method: 'get',
					url: this.url + '/lab/getEtcDefaultMinerList',
					headers: {
						'token': this.token
					}
				};

				await axios(config)
					.then(function(response) {
						that.minerData = response.data.data
						that.minerid = response.data.data.id
						// console.log(JSON.stringify(response.data));
					})
					.catch(function(error) {
						console.log(error);
					});

			},
			async initAllMiners() { //打开子账户切换对话框
				let that = this
				var config = {
					method: 'get',
					url: this.url + '/lab/getEtcMinerList',
					headers: {
						'token': this.token
					}
				};

				await axios(config)
					.then(function(response) {
						that.minerList = response.data.data
					})
					.catch(function(error) {
						console.log(error);
					});
			},

			async exchangeMiner() { //打开子账户切换对话框
				let that = this
				var config = {
					method: 'get',
					url: this.url + '/lab/getEtcMinerList',
					headers: {
						'token': this.token
					}
				};

				await axios(config)
					.then(function(response) {
						that.minerList = response.data.data
						that.echangeMiner = true
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			checkUserStatus() { //检查用户状态
				let that = this
				var config = {
					method: 'post',
					url: this.url + '/api/user/status',
					headers: {
						'token': this.token
					}
				};

				axios(config)
					.then(function(response) {
						that.userStatus = response.data.data
						if (response.data.data === -2) {
							that.getOPT()
							that.optshow=true
						}
						// console.log(JSON.stringify(response.data));
					})
					.catch(function(error) {
						console.log(error);
					});
				// console.log(this.userStatus)
			},
			async validopt(value) {
				let that = this
				var data = qs.stringify({
					'code': value
				});
				var config = {
					method: 'post',
					url: this.url + '/api/user/validCode',
					headers: {
						'token': this.token,
						'Content-Type': 'application/x-www-form-urlencoded'
					},
					data: data
				};

				await axios(config)
					.then(function(response) {
						// console.log("this.optRes:"+that.optRes)
						that.optRes = response.data.data
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			submitopt() {
				let that = this
				var data = qs.stringify({
					'method': 'bindopt',
					'code': this.google.opt
				});
				var config = {
					method: 'post',
					url: this.url + '/api/user/validCode',
					headers: {
						'token': this.token,
						'Content-Type': 'application/x-www-form-urlencoded'
					},
					data: data
				};

				axios(config)
					.then(function(response) {
						if (response.data.data === true) {
							that.userStatus = 0
							that.optshow = false
							that.$message.success(that.$t('labseth.bindsuccess'))
						} else {
							that.$message.error(that.$t('labseth.codeerr1'))
						}
						// console.log(JSON.stringify(response.data));
					})
					.catch(function(error) {
						console.log(error);
					});
				// console.log("submitopt")
			},
			copykey(ele) {
				let that = this
				var clipboard = new Clipboard('.copyButton')
				clipboard.on('success', e => {
					this.$notify({
						title: that.$t('labseth.copysuccess'),
						message: that.$t('labseth.copytip'),
						type: 'success'
					});
					// 释放内存
					clipboard.destroy();
				})
				clipboard.on('error', e => {
					// 不支持复制
					// 释放内存
					clipboard.destroy()
				})
				// console.log("copy")
			},
			onSubmitPaymentAccount() {
				let that = this
				var data = qs.stringify({
					'minerid': this.minerid, //parseInt(this.addPaymentAccountForm.minerid)
					'type': parseInt(this.addPaymentAccountForm.type),
					'account': this.addPaymentAccountForm.account,
					'name': this.addPaymentAccountForm.name,
					"model": "etc"
				});
				if (parseInt(this.addPaymentAccountForm.type) === 2 || parseInt(this.addPaymentAccountForm.type) === 3) {

					const reg = /^(0x)?[0-9a-fA-F]{40}$/;
					if (!reg.test(this.addPaymentAccountForm.account)) {
						this.$message.error("ETH地址错误")
						return
					}
				}
				if (this.addPaymentAccountForm.account.length != 8 && this.addPaymentAccountForm.type === '1') {
					this.$message.error("支付密钥必须为8位")
					return
				}
				// console.log(data)
				var config = {
					method: 'post',
					url: this.url + '/lab/setAccount?models=ETC',
					headers: {
						'token': this.token,
						'Content-Type': 'application/x-www-form-urlencoded'
					},
					data: data
				};

				axios(config)
					.then(function(response) {
						if (response.data.code === 0) {
							that.$message.success(that.$t('labseth.addsuccess'))
							that.addpaymentaccountDialog = false
						} else {
							that.$message.error(that.$t('labseth.addfail'))
							that.addpaymentaccountDialog = false
						}
					})
					.catch(function(error) {
						console.log(error);
					});

			},
			// onSubmitPayment() {
			// 	let that = this
			// 	this.checkUserStatus()
			// 	this.openFullScreen2()
			// 	if (this.userStatus === -2) { //未绑定用户
			// 		this.$message.error(that.$t('labseth.unbindgoogel'))
			// 		this.optshow = true
			// 	} else if (this.userStatus === -1) { //封禁用户
			// 		this.$message.error(that.$t('labseth.banaccount'))
			// 	} else {

			// 		var eth = 0
			// 		if (this.addPaymentOrderForm.payType === '1') {
			// 			if (this.fix2(this.ethPrice.eth2cny * this.addPaymentOrderForm.usdt) < 100) {
			// 				// console.log("小于100")
			// 				this.$message.warning(that.$t('labseth.cnypaytip'))
			// 				return
			// 			}
			// 			let drv = this.addPaymentOrderForm.money / this.fix2(this.ethPrice.eth2cny * this.formatEthBalance(
			// 				this.minerData.eth_balance))
			// 			// eth = drv * this.minerData.eth_balance
			// 			eth = this.addPaymentOrderForm.usdt
			// 			// console.log("22")
			// 			// console.log(this.addPaymentOrderForm.usdt)
			// 			// console.log(this.addPaymentOrderForm.eth)
			// 			// this.addPaymentOrderForm.usdt = this.addPaymentOrderForm.eth
			// 			this.addPaymentOrderForm.payType = '1'
			// 			this.addPaymentOrderForm.eth = eth

			// 			// eth=this.addPaymentOrderForm.money/this.ethPrice.eth2cny
			// 		} else if (this.addPaymentOrderForm.payType === '0') {
			// 			if (this.fix2(this.ethPrice.eth2usdt * this.addPaymentOrderForm.usdt) < 20) {
			// 				this.$message.warning($t('labseth.usdtpaytip'))
			// 				return
			// 			}
			// 			// let drv = this.addPaymentOrderForm.usdt / this.fix2(this.ethPrice.eth2usdt * this.formatEthBalance(
			// 			// 	this.minerData.eth_balance))
			// 			// eth = drv * this.minerData.eth_balance
			// 			eth = this.addPaymentOrderForm.usdt
			// 			this.addPaymentOrderForm.money = 0
			// 			this.addPaymentOrderForm.payType = '0'
			// 			this.addPaymentOrderForm.eth = eth
			// 		} else if (this.addPaymentOrderForm.payType === '2') {



			// 			const reg = /^(0x)?[0-9a-fA-F]{40}$/;
			// 			if (!reg.test(this.addPaymentOrderForm.paymentAccount)) {
			// 				this.$message.error("ETH地址错误")
			// 				return
			// 			}


			// 			if (this.addPaymentOrderForm.usdt < 0.01) {
			// 				this.$message.warning($t('labseth.ethpaytip'))
			// 				return
			// 			}
			// 			eth = this.addPaymentOrderForm.usdt
			// 			this.addPaymentOrderForm.money = 0
			// 			this.addPaymentOrderForm.payType = '2'
			// 			this.addPaymentOrderForm.eth = eth
			// 		} else if (this.addPaymentOrderForm.payType === '3') {



			// 			const reg = /^(0x)?[0-9a-fA-F]{40}$/;
			// 			if (!reg.test(this.addPaymentOrderForm.paymentAccount)) {
			// 				this.$message.error("ETH地址错误")
			// 				return
			// 			}


			// 			if (this.addPaymentOrderForm.usdt < 0.01) {
			// 				this.$message.warning($t('labseth.ethpaytip'))
			// 				return
			// 			}
			// 			eth = this.addPaymentOrderForm.usdt
			// 			this.addPaymentOrderForm.money = 0
			// 			this.addPaymentOrderForm.payType = '3'
			// 			this.addPaymentOrderForm.eth = eth
			// 		}
			// 		// console.log(this.addPaymentOrderForm)
			// 		var data = qs.stringify(
			// 			this.addPaymentOrderForm
			// 		);
			// 		var config = {
			// 			method: 'post',
			// 			url: this.url + '/lab/createPaymentOrder',
			// 			headers: {
			// 				'token': this.token,
			// 				'Content-Type': 'application/x-www-form-urlencoded'
			// 			},
			// 			data: data
			// 		};
			// 		this.fullscreenLoading = true
			// 		axios(config)
			// 			.then(function(response) {
			// 				if (response.data.code === 0) {
			// 					that.$message.success(that.$t('labseth.addpaysuccess'))
			// 					that.initPaymentOrder()
			// 					that.loading = that.$loading({
			// 						lock: true,
			// 						text: 'Loading',
			// 						spinner: 'el-icon-circle-check',
			// 						background: 'rgba(0, 0, 0, 0.7)'
			// 					});
			// 					that.initMinerData()
			// 					that.loading.close()
			// 					that.fullscreenLoading = false
			// 				} else if (response.data.code === 14008) {
			// 					that.fullscreenLoading = false
			// 					that.loading = that.$loading({
			// 						lock: true,
			// 						text: 'Loading',
			// 						spinner: 'el-icon-circle-close',
			// 						background: 'rgba(0, 0, 0, 0.7)'
			// 					});
			// 					that.loading.close()
			// 					that.$message.error(that.$t('labseth.addpayfail'))
			// 				} else if (response.data.code === 14009) {
			// 					that.loading = that.$loading({
			// 						lock: true,
			// 						text: 'Loading',
			// 						spinner: 'el-icon-circle-close',
			// 						background: 'rgba(0, 0, 0, 0.7)'
			// 					});
			// 					that.loading.close()
			// 					that.fullscreenLoading = false
			// 					that.$message.warning(that.$t('labseth.addpayonceday'))
			// 				} else if (response.data.code === 14010) {
			// 					that.loading = that.$loading({
			// 						lock: true,
			// 						text: 'Loading',
			// 						spinner: 'el-icon-circle-close',
			// 						background: 'rgba(0, 0, 0, 0.7)'
			// 					});
			// 					that.loading.close()
			// 					that.fullscreenLoading = false
			// 					that.$message.error(that.$t('labseth.addpaybalanceinsuff'))
			// 				} else if (response.data.code === 14013) {
			// 					that.loading = that.$loading({
			// 						lock: true,
			// 						text: 'Loading',
			// 						spinner: 'el-icon-circle-close',
			// 						background: 'rgba(0, 0, 0, 0.7)'
			// 					});
			// 					that.loading.close()
			// 					that.fullscreenLoading = false
			// 					that.$message.error(that.$t('labseth.unbindemaill'))
			// 				} else if (response.data.code === 14014) {
			// 					that.loading = that.$loading({
			// 						lock: true,
			// 						text: 'Loading',
			// 						spinner: 'el-icon-circle-close',
			// 						background: 'rgba(0, 0, 0, 0.7)'
			// 					});
			// 					that.loading.close()
			// 					that.fullscreenLoading = false
			// 					that.$message.error(that.$t('labseth.alipaykeyerr'))
			// 				} else if (response.data.code === 14015) {
			// 					that.fullscreenLoading = false
			// 					that.loading = that.$loading({
			// 						lock: true,
			// 						text: 'Loading',
			// 						spinner: 'el-icon-circle-close',
			// 						background: 'rgba(0, 0, 0, 0.7)'
			// 					});
			// 					that.loading.close()
			// 					that.$message.error(that.$t('labseth.addresserr'))
			// 				} else if (response.data.code === 14016) {
			// 					that.fullscreenLoading = false
			// 					that.$message.error(that.$t('labseth.temporarymaintenance'))
			// 				} else if (response.data.code === -2) {
			// 					that.fullscreenLoading = false
			// 					that.$notify.error({
			// 						title: that.$t('navbar.error'),
			// 						message: that.$t('labseth.noresubmit')
			// 					});
			// 				} else {
			// 					that.loading = that.$loading({
			// 						lock: true,
			// 						text: 'Loading',
			// 						spinner: 'el-icon-circle-close',
			// 						background: 'rgba(0, 0, 0, 0.7)'
			// 					});
			// 					that.loading.close()
			// 					that.fullscreenLoading = false
			// 					that.$message.error(that.$t('labseth.unknownerr'))
			// 				}
			// 				// console.log(JSON.stringify(response.data));
			// 			})
			// 			.catch(function(error) {
			// 				that.fullscreenLoading = false
			// 				console.log(error);
			// 			});
			// 	}
			// 	// let tmp={}



			// 	// console.log(this.addPaymentOrderForm)
			// },
			async handleClick(tab) {
				if (tab.name === "third") {
					await this.initPaymentAccount()
					// console.log("third")
				} else if (tab.name === "first") {
					this.onlineCurrentChange1(1)
					// console.log("first")
				} else if (tab.name === "fifth") {
					await this.initPaymentAccount()
					// console.log(this.paymentAccount['data'])
					// this.initPaymentAccount()
					// console.log("first")
				} else {
					// console.log("second")
				}
			},

			chartResize() {
				let eleArr = [this.myChart];
				for (let i = 0; i < eleArr.length; i++) {
					//此处定时器是为了在页面存在多个图时，resize方法的调用时间微微错开，避免明显的卡顿
					setTimeout(function() {
						eleArr[i].resize();
					}, 200);
				}
			},

			dateformat(ts) {

				var time = new Date().getTime() / 1000 - ts;
				console.log(time)
				if (time < 60 && time > 0) {
					time = time.toFixed(0) + this.$t('anonminer.secago');
				} else if (time >= 60 && time < 3600) {
					time = Math.floor(time / 60) + this.$t('anonminer.minago');
				} else if (time >= 3600 && time < 3600 * 24) {
					time = Math.floor(time / 3600) + this.$t('anonminer.hourago');
				} else if (time >= 3600 * 24 && time < 3600 * 24 * 30) {
					time = Math.floor(time / 3600 / 24) + this.$t('anonminer.dayago');
				} else if (time >= 3600 * 24 * 30) {
					time = Math.floor(time / 3600 / 24 / 30) + this.$t('anonminer.monago');
				} else {
					time = this.$t('anonminer.onesecago');
				}
				return time;
			},
			formatter2: function(value) {
				value = value * 1.0
				if (value >= 1 && value < 1000) {
					return value.toFixed(2) + 'H/s';
				} else if (value >= 1000 && value < 1000000) {
					return (value / 1000).toFixed(2) + 'KH/s';
				} else if (value >= 1000000 && value < 1000000000) {
					return (value / 1000000).toFixed(2) + 'MH/s';
				} else if (value >= 1000000000 && value < 1000000000000) {
					return (value / 1000000000).toFixed(2) + 'GH/s';
				} else if (value >= 1000000000000) {
					return (value / 1000000000000).toFixed(2) + 'TH/s';
				} else if (value > 0 && value < 1) {
					return value.toFixed(6) + 'H/s';
				} else if (value == 0) {
					return 0;
				}
			},
			dataformater2(value) {
				let date = new Date(value);
				let y = date.getFullYear();
				let MM = date.getMonth() + 1;
				MM = MM < 10 ? ('0' + MM) : MM;
				let d = date.getDate();
				d = d < 10 ? ('0' + d) : d;
				let h = date.getHours();
				h = h < 10 ? ('0' + h) : h;
				let m = date.getMinutes();
				m = m < 10 ? ('0' + m) : m;
				let s = date.getSeconds();
				s = s < 10 ? ('0' + s) : s;
				// return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
				return h + ':' + m;
			},
			async initPaymentOrder() { //加载历史支付记录数据
				let that = this
				var data = qs.stringify({
					'minername': this.minerData.miner_name
				});
				var config = {
					method: 'get',
					url: this.url + '/lab/payments?address='+this.minerData.miner_name,
					headers: {
						'token': this.token,
					}
				};

				await axios(config)
					.then(function(response) {
						// console.log("payment",response.data)
						if (response.data.code === 4002) {
							that.$router.push({
								path: "/login?redirect=/labs/etc-index"
							});
						} else if (response.data.code === 0) {
							that.paymentOrderList = response.data.data
						} else if (response.data.code === 4006) {
							that.$message.warning(response.data.msg)
						} else {
							that.$message.warning("未知错误")
						}

						// console.log(JSON.stringify(response.data));
					})
					.catch(function(error) {
						console.log(error);
					});

			},
			formatter(value) {
				value = value * 1
				// console.log(value)
				if (value > 0 && value < 1000) {
					return value.toFixed(2) + '| H/s'
					//.toFixed(2) + '| H/s';
				} else if (value >= 1000 && value < 1000000) {
					return (value / 1000).toFixed(2) + '| KH/s';
				} else if (value >= 1000000 && value < 1000000000) {
					return (value / 1000000).toFixed(2) + '| MH/s';
				} else if (value >= 1000000000 && value < 1000000000000) {
					return (value / 1000000000).toFixed(2) + '| GH/s';
				} else if (value >= 1000000000000) {
					return (value / 1000000000000).toFixed(2) + '| TH/s';
				} else if (value == 0) {
					return 0 + '| H/s';
				}
			},
			async initMiner() { //加载矿工矿机数据
				let that = this
				var config = {
					method: 'get',
					url: this.url + '/lab/getMiner?miner=' + this.minerData.miner_name + "&type=ETC",
					headers: {
						'token': this.token
					},
					data: {}
				};
				let timeNow = new Date().getTime()/1000
				// console.log("timeNow:" + timeNow.getTime())
				await axios(config).then(function(response) {
						if (response.data.code === 4002) {
							that.$router.push({
								path: "/login?redirect=/labs/etc-index"
							});
						}
						for (var item in response.data.data) {
							// console.log(timeNow, response.data.data[item].lastShare,timeNow - response.data.data[item].lastShare > 1000 * 60 * 10)
							if( response.data.data[item].lastShare===undefined){
								that.offlineminer.unshift(response.data.data[item])
							}else  if (timeNow - response.data.data[item].lastShare >  60 * 10||response.data.data[item].status==="offline") {
								that.offlineminer.unshift(response.data.data[item])
							} else {
								that.onlineminer.unshift(response.data.data[item])
								that.total_hash = that.total_hash + response.data.data[item].hashrate
							}
						}
						var temp = that.formatter(that.total_hash).split("|")
						// console.log(temp)
						that.total_hash = temp[0]
						that.total_hashUnit = temp[1]

						that.total_offline = that.offlineminer.length
						that.total_online = that.onlineminer.length
						that.minerdataloading = false
						that.offlineloading = false
					})
					.catch(function(error) {
						console.log(error);
					});
				// console.log(this.allminer)
			}
		}

	}
</script>

<style scoped>
	body {
		background-color: #F7FAFC;

	}

	.card-li {
		float: left;
		width: 50%;
		color: rgb(153, 153, 153);
		font-size: 16px;
	}

	.hash-card {
		/* padding: 10px 20px; */
	}

	.el-card__header {
		padding: 10px 20px;
		border-bottom: 1px solid #EBEEF5;
		box-sizing: border-box;
	}

	.grid-content {}

	.quick-start {
		background-color: white;
		width: 100%;
		border-radius: 5px;
	}

	/* **********************手机******************************** */
	@media screen and (max-width: 768px) {
		.content-header-l-l {
			color: white;
			float: left;
			margin-left: 5px;
			margin-top: 30px;
			font-size: 18px;
		}

		.content-header-l-l span {
			font-size: 10px;
			color: #bdbdbd;
			margin-top: 10px;
		}

		.content-header-l-r {
			color: white;
			float: right;
			margin-right: 5px;
			margin-top: 30px;
			font-size: 18px;
		}

		.content-header-l-r span {
			font-size: 10px;
			color: #bdbdbd;
			margin-top: 20px;
		}

		.content-header-r {
			background-color: #FFFFFF;
			height: 120px;
			border-radius: 5px;
		}

		.content-header-r-main label {
			font-size: 20px;
		}

		.content-header-r-main span {
			font-size: 16px;
		}

		.earning-title {
			margin-left: 10px;
			font-size: 24px;
		}

		.earning-content {
			margin-top: 15px;
		}

		.earning-content label {
			font-size: 14px;
		}

		.earning-content span {
			font-size: 18px;
		}

		.box-card {
			border-radius: 5px;
			margin-top: 15px;
		}

		#earning-realtime {
			width: 100%;
			height: 220px;
		}

		.withdrawal-content-card-2 {
			margin-top: 15px;
		}

		.el-message-box {
			width: 300px;
		}

		.content-header-middle {
			height: 180px;
			background-color: #ffffff;
			border-radius: 5px;
		}

		.earnings {
			margin-top: 30px;
		}


	}

	/* ****************************************************** */


	/* *********************笔记本********************************* */
	@media screen and (min-width: 768px) and (max-width: 1200px) {
		.content-header-l-l {
			color: white;
			float: left;
			margin-left: 5px;
			margin-top: 20px;
			font-size: 20px;
		}

		.content-header-l-l span {
			font-size: 14px;
			color: #bdbdbd;
			margin-top: 10px;
		}

		.content-header-l-r {
			color: white;
			float: right;
			margin-right: 15px;
			margin-top: 20px;
			font-size: 20px;

		}

		.content-header-l-r span {
			font-size: 14px;
			color: #bdbdbd;
			margin-top: 20px;
		}

		.content-header-r {
			/* margin-left: 20px; */
			background-color: #FFFFFF;
			height: 120px;
			border-radius: 5px;
		}

		.content-header-r-main label {
			/* color: #bdbdbd; */
			font-size: 20px;
		}

		.content-header-r-main span {

			font-size: 16px;
		}

		.content-earning {
			border-radius: 5px;
		}

		.earning-content {
			margin-top: 15px;
		}

		.earning-title {
			margin-left: 15px;
			font-size: 24px;
		}

		.earning-content label {
			font-size: 14px;
		}

		.earning-content span {
			font-size: 20px;
		}

		.box-card {
			border-radius: 5px;
			margin-top: 15px;
		}

		#earning-realtime {
			width: 100%;
			height: 300px;
		}

		.content-header-middle {
			height: 180px;
			background-color: #ffffff;
			border-radius: 5px;
		}

		.earnings {
			margin-top: 30px;
		}

	}

	/* ****************************************************** */

	/* *********************台式机********************************* */
	@media screen and (min-width: 1200px) {
		.content-header-l-l {
			color: white;
			float: left;
			margin-left: 5px;
			margin-top: 20px;
			font-size: 26px;
		}

		.content-header-l-l span {
			font-size: 14px;
			color: #bdbdbd;
			margin-top: 10px;
		}

		.content-header-l-r {
			color: white;
			float: right;
			margin-right: 15px;
			margin-top: 20px;
			font-size: 24px;
		}

		.content-header-l-r span {
			font-size: 14px;
			color: #bdbdbd;
			margin-top: 20px;
		}

		.content-header-r {
			/* margin-left: 20px; */
			/* background-color: #FFFFFF; */
			height: 120px;
			border-radius: 5px;
		}

		.content-header-r-main label {
			font-size: 24px;
		}

		.content-header-r-main span {
			font-size: 16px;
		}

		.earning-content {
			margin-top: 15px;
		}

		.earning-title {
			margin-left: 15px;
			font-size: 24px;
		}

		.earning-content label {
			font-size: 14px;
		}

		.earning-content span {
			font-size: 22px;
		}

		.box-card {
			border-radius: 5px;
			margin-top: 15px;
		}

		#earning-realtime {
			width: 100%;
			height: 420px;
		}

		.earnings {

			margin-top: 30px;
		}


	}




	/* *********************适配三格窗********************************* */
	@media screen and (min-width: 992px) and (max-width: 1520px) {

		.content-header-middle {

			height: 120px;
			font-size: 16px;
			background-color: #ffffff;
			border-radius: 5px;
		}

		.content-header-r-main label {
			font-size: 16px;
		}

		.earnings {
			margin-top: 10px;
		}
	}

	/* *********************适配三格窗********************************* */
	@media screen and (min-width: 1200px) and (max-width: 1520px) {
		.earnings {
			margin-top: 35px;
		}

		.content-header-l label {
			font-size: 22px;
		}

	}

	/* ****************************************************** */
	.content {
		width: 90%;
		margin: 0 auto;
		border-radius: 0.3125rem;

	}

	.el-dialog {
		overflow: auto;
	}

	.my-account h2 {
		font-size: 24px;
		margin-bottom: 24px;
		font-weight: 300;
		color: var(--heading-color);
	}

	.content-header-l {
		background-color: #FFFFFF;
		height: 120px;
		border-radius: 5px;
	}

	.content-header-r-main {
		background-color: #FFFFFF;
		height: 120px;
		border-radius: 5px;
	}


	.header-col {
		margin-top: 10px;
	}

	.content-main {
		width: 100%;
	}
</style>
